<template>
  <h2 class="test-title">{{ $t("testBBB.config") }}</h2>
</template>

<script>
export default {
  name: "pageTitle"
}
</script>

<style lang="scss">
.test-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 0;
  font-family: Unistra A !important;
}
</style>
